import React, { useEffect, useState, useRef } from "react"
import { trans } from "../../../../_providers/Translation"
import Api from "@/_helpers/Api"
import Skeleton from "react-loading-skeleton"
import DualBarChart from "../../../partials/DualBarChart"
import { Button } from "@mui/material"
import CompactFilterLayout from "@/components/partials/CompactFilterLayout"
import DateRange from "@/components/partials/DateRange"
import filterImage from "@/assets/img/icons/filter.svg"

const INITIAL_FILTERS = {
  date_from: null,
  date_to: null,
}

export default function BonusPolicies() {
  const STATUSES = [
    { name: trans("tabs.completed"), color1: "#BEDDC9", color2: "#A3D9B1" },
    { name: trans("random.remaining"), color1: "#D4E6E9", color2: "#B0D8E6" },
  ]

  const [state, setState] = useState({
    loading: true,
    employees: [],
    forecastDates: [],
    completed: [],
    uncompleted: [],
    filterTypes: [],
  })
  const [filters, setFilters] = useState(INITIAL_FILTERS)

  const compactFilterLayoutRef = useRef(null)
  const fetchDebounceRef = useRef(null)

  useEffect(() => {
    clearTimeout(fetchDebounceRef.current)
    fetchDebounceRef.current = setTimeout(() => {
      loadData()
    }, 300)
    return () => clearTimeout(fetchDebounceRef.current)
  }, [filters])

  const loadData = () => {
    setState((prev) => ({ ...prev, loading: true }))

    Api.get(
      `dashboard/employees/targets-forecast?selected_policy_id=${filters.policy_id || ""}`,
    )
      .then((res) => {
        const employees = res.data.chart_format || []
        setState((prev) => ({
          ...prev,
          employees: employees.map((e) => e.name),
          forecastDates: employees.map((e) => e.forecast_date || ""),
          completed: employees.map((e) => e.completed || 0),
          uncompleted: employees.map((e) => e.remaining || 0),
          filterTypes: res.data.filter_options || [],
        }))
      })
      .finally(() => {
        setState((prev) => ({ ...prev, loading: false }))
      })
  }

  function handleFilterChange(name, value) {
    setFilters((prev) => ({ ...prev, [name]: value }))
  }

  function getAppliedFiltersCount() {
    return filters.policy_id ? 1 : 0
  }

  return (
    <div className="employees-reservations-chart">
      <div className="head">
        <h3>{trans("headings.lastAddedBonusPolicy")}</h3>
        <div className="right">
          <ul>
            {STATUSES.map((status) => (
              <li key={status.name}>
                <span
                  style={{
                    background: status.color2
                      ? `linear-gradient(to bottom, ${status.color1}, ${status.color2})`
                      : status.color1,
                  }}
                ></span>
                {status.name}
              </li>
            ))}
          </ul>
          <Button
            onClick={(e) => {
              compactFilterLayoutRef.current.open(e)
            }}
          >
            <img src={filterImage} alt="Filter" />
            {getAppliedFiltersCount() ? (
              <i>{getAppliedFiltersCount()}</i>
            ) : (
              <></>
            )}
          </Button>
          <CompactFilterLayout
            ref={compactFilterLayoutRef}
            appliedFiltersCount={getAppliedFiltersCount()}
            onClearClick={() => setFilters(INITIAL_FILTERS)}
          >
            <div className="row">
              <div className="col">
                {/* <DateRange
                    startDate={filters.date_from || ''}
                    endDate={filters.date_to || ''}
                    onStartDateChange={(date) => handleFilterChange('date_from', date)}
                    onEndDateChange={(date) => handleFilterChange('date_to', date)}
                  /> */}

                {state.loading && !state.filterTypes.length ? (
                  <Skeleton height={40} width={140} count={1} />
                ) : (
                  <select
                    value={filters.policy_id || ""}
                    name="policy_id"
                    onChange={(e) =>
                      handleFilterChange("policy_id", e.target.value)
                    }
                  >
                    {state.filterTypes.map((filterType) => (
                      <option key={filterType.id} value={filterType.id}>
                        {`${filterType.type_name} (${filterType.period})`}
                      </option>
                    ))}
                  </select>
                )}
              </div>
            </div>
          </CompactFilterLayout>
        </div>
      </div>
      <hr />
      {state.loading ? (
        <Skeleton count={1} height={360} />
      ) : state.employees.length === 0 ? (
        <div
          className="alert warning"
          style={{ width: "100%", marginBottom: "auto" }}
        >
          {trans("messages.noDataFound")}
        </div>
      ) : (
        <DualBarChart
          labels={state.employees}
          series={[
            {
              name: STATUSES[0].name,
              color1: STATUSES[0].color1,
              color2: STATUSES[0].color2,
              data: state.completed,
            },
            {
              name: STATUSES[1].name,
              color1: STATUSES[1].color1,
              data: state.uncompleted,
              meta: state.forecastDates.map((d) =>
                d ? `${trans("random.forecastEndDate")}: ${d}` : null,
              ),
            },
          ]}
        />
      )}
    </div>
  )
}
